//import Moment from "moment";

const dataFormatada = (state) => {
    if (!state.permissao || !state.permissao.data) return null;
    return Moment(String(state.permissao.data)).format("DD/MM/YYYY");
}

const getCount = (state) => {
	return state.permissoes.length;
}

export default {
    dataFormatada,
	getCount
}